import { PUBLIC_DOMAIN_URL } from '../_constants/urls'

export const normalizeDestinationUrl = (destinationUrl: string) => {
    const normalizedDestinationUrl = destinationUrl.startsWith('/')
        ? `${PUBLIC_DOMAIN_URL}${destinationUrl}`
        : destinationUrl

    return normalizedDestinationUrl
}
